import React from 'react';
import { MapPin, Plane, Building2, Tent } from 'lucide-react';
import { Location } from '../../../types/movement';
import { useLanguage } from '../../../contexts/LanguageContext';

type Props = {
  location: Location;
};

export const LocationBadge = ({ location }: Props) => {
  const { translations } = useLanguage();

  const getIcon = () => {
    switch (location.type) {
      case 'airport':
        return Plane;
      case 'hotel':
        return Building2;
      case 'camp':
        return Tent;
      default:
        return MapPin;
    }
  };

  const getColors = () => {
    switch (location.city) {
      case 'makkah':
        return 'bg-primary-50 text-primary-700';
      case 'madinah':
        return 'bg-green-50 text-green-700';
      case 'jeddah':
        return 'bg-blue-50 text-blue-700';
      default:
        return 'bg-gray-50 text-gray-700';
    }
  };

  const getCityName = (city: string): string => {
    switch (city) {
      case 'makkah':
        return translations?.cities?.makkah || 'Makkah';
      case 'madinah':
        return translations?.cities?.madinah || 'Madinah';
      case 'jeddah':
        return translations?.cities?.jeddah || 'Jeddah';
      default:
        return city;
    }
  };

  const Icon = getIcon();

  return (
    <div className="space-y-1">
      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium ${getColors()}`}>
        <Icon size={14} />
        {location.name}
      </span>
      <div className="text-xs text-gray-500 pr-2">
        {getCityName(location.city)}
      </div>
    </div>
  );
};